'use client';

import { useMemo } from 'react';

import { usePersistedUserNavigationSearchParams } from '@/hooks/navigation/use-persisted-session-navigation-params.hook';
import { useSearchParams } from '@/hooks/use-search-params.hook';
import { PersistedUserNavigationSearchParams } from '@/types/enums/persisted-user-navigation-search-params.enum';

export default function useGoToHome() {
  const searchParams = useSearchParams(Object.values(PersistedUserNavigationSearchParams));
  const city = searchParams[PersistedUserNavigationSearchParams.CIDADE];

  const baseLink = useMemo(() => {
    if (city) {
      return `/cidades/${city}/`;
    }
    return '/';
  }, [city]);

  return usePersistedUserNavigationSearchParams(baseLink);
}
